import { CircularProgress } from "@mui/material";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSafeWindow } from "../../../hooks/useSafe";

const containerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  paddingTop: "100px",
  flexDirection: "column",
  gap: "20px",
};

function NewInvestorTxnFeedback() {
  const safeWindow = useSafeWindow()
  const history = useHistory();
  const pgResponse = document?.getElementById("root")?.attributes[1]?.value;
  const getd = JSON.parse(pgResponse || "{}");

  console.log("getd*****", getd, history.location);
  useEffect(() => {
    console.log("getd*****", getd, history.location);

    history.replace(`${history.location.pathname}?billdesk=${getd?.msg}`);

    if (safeWindow?.navigator?.userAgent === "NewInvestorApp") {
      safeWindow?.ReactNativeWebView?.postMessage(getd?.msg);
    }
  }, [getd?.msg, safeWindow?.navigator]);

  return (
    <div style={containerStyle}>
      <h2>Please wait!</h2>
      <CircularProgress />
    </div>
  );
}

export default NewInvestorTxnFeedback;
